import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "borders", "scrollable", "snapping", "fixedLayout", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './TableBasic.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseTableBasic = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$borders = _ref.borders,
      borders = _ref$borders === void 0 ? "vertical" : _ref$borders,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable,
      _ref$snapping = _ref.snapping,
      snapping = _ref$snapping === void 0 ? false : _ref$snapping,
      _ref$fixedLayout = _ref.fixedLayout,
      fixedLayout = _ref$fixedLayout === void 0 ? false : _ref$fixedLayout,
      tokens = _ref.tokens,
      props = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.TableContainer, _objectSpread(_objectSpread({
    scrollable: scrollable,
    tabIndex: 0
  }, tokens), {}, {
    children: _jsx(views.TableWrapper, _objectSpread(_objectSpread({
      snapping: snapping,
      borders: borders
    }, tokens), {}, {
      children: _jsx(views.StyledTable, _objectSpread(_objectSpread(_objectSpread({
        borders: borders,
        fixedLayout: fixedLayout
      }, tokens), props), {}, {
        ref: ref,
        children: children
      }))
    }))
  }));
});
export var TableBasic = withDesignTokens(BaseTableBasic, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      borderColor: theme.palette.twilio.gray[30]
    };
  }
});